/**
 * SwapIcon/index.js
 * desc: content swap icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const SwapIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="swap icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.swap.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fillRule="evenodd" d="M8.238 6.463L1.763 0 0 1.762l6.463 6.463 1.775-1.762zM13.125 0l2.55 2.55L0 18.238 1.762 20 17.45 4.325 20 6.875V0h-6.875zm-1.35 13.525l1.762-1.763 3.913 3.913 2.55-2.55V20h-6.875l2.563-2.563-3.913-3.912z"/></svg>
    </IconButton>
);


export default SwapIcon;
